
























import Vue from 'vue';
import { ICustomSelectOption } from '../../../common/interfaces/shared.interface';

interface IFilterSelectRefs {
  filterSelect: HTMLSelectElement;
}

export default Vue.extend({
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): { $refs?: IFilterSelectRefs } {
    return {};
  },
  props: {
    defaultOption: {
      default: ``,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: ``,
      type: String,
    },
    options: {
      default: () => [],
      type: Array as () => ICustomSelectOption[],
    },
    title: {
      default: ``,
      type: String,
    },
  },
  methods: {
    clear(): void {
      this.$refs.filterSelect.selectedIndex = 0;
    },
    set(value: string): void {
      this.$refs.filterSelect.value = value;
    },
  },
});
